/* eslint-disable no-unused-vars */
import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar/Navbar'
import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar'
import { useParams } from 'react-router-dom'
import CoursesCategory from '../../api/CoursesCategory'
import Footer from '../../components/footer/Footer';
import CoureseTab from './Tabs/CoureseTab';
import Sidebar from './sidebar';
import { useLanguage } from '../../i18n/LanguageContext';

const CategorySinglePage = (props) => {
    const { slug } = useParams()
    const { t } = useLanguage();

    const CoursesCategoryDetails = CoursesCategory.find(item => item.slug === slug)
    const translatedTitle = t(`cooking.items.${CoursesCategoryDetails.Id}.title`);

    return (
        <Fragment>
            <Navbar />
            <PageTitle pageTitle={translatedTitle} pagesub={t('cooking.title')} />
            <div className="wpo-course-details-area section-padding">
                <div className="container">
                    <div className="row">
                        <div className="col col-lg-8">
                            <div className="wpo-course-details-wrap">
                                <div className="wpo-course-details-img">
                                    <img src={CoursesCategoryDetails.cImg} alt={translatedTitle} />
                                </div>
                                <p>{t(`cooking.items.${CoursesCategoryDetails.Id}.description`)}</p>
                                {/* <CoureseTab CoursesCategoryDetails={CoursesCategoryDetails} /> */}
                            </div>
                        </div>
                        {/* <Sidebar /> */}
                    </div>
                </div>
            </div>
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};
export default CategorySinglePage;
